import axios from 'axios';
import {
  IMainToolsData,
  IMainToolsDataSwipes,
  ISwipe,
  ISwipeCategory,
} from './interfaces';
import { AlchemyEncryptor } from '../tools/crypto';

export class BlobToolsAPI {
  static host = 'https://web.alchemy-app.com/api/';

  static encryptor: AlchemyEncryptor = new AlchemyEncryptor(
    'QXJlIHlvdSBoYXBweT8gQmUgaG9uZXN0LiBJIGtub3cgdGhpcyB3b3JsZCBjYW4gaHVydC4uLiBJIGtub3cgaXQgbXlzZWxmLCBidXQgeW91IGNhbiBnZXQgdGhyb3VnaCBpdC4gSnVzdCBkbyBnb29kIHRoaW5ncy4gRm9yIGV4YW1wbGUsIGZlZWQgYSBzdHJheSBjYXQuIEkga25vdyB5b3UgYXJlIGEgZ29vZCBwZXJzb24uJw=='
  );

  static async getMainData(): Promise<IMainToolsData | null> {
    const response = await axios.get(this.host + '/shop/get-tools-prompts/');

    return ((response?.data as IMainToolsData) ?? null)
      ? {
          ...response.data,
          results: (response.data as IMainToolsData).results.sort(
            (a, b) => a.id - b.id
          ),
        }
      : null;
  }

  static async getSwipes(category?: number): Promise<ISwipe[]> {
    try {
      const res = (
        await axios.get(this.host + `/sidebar/swipes/`, {
          params: { category },
        })
      ).data;

      return res.results as ISwipe[];
    } catch (err) {
      console.error('🛑 Error detected', err);
      throw err;
    }
  }

  static async getSwipeCategories(): Promise<ISwipeCategory[]> {
    try {
      const res = (await axios.get(this.host + `/sidebar/swipes/categories/`))
        .data;

      return res.results as ISwipeCategory[];
    } catch (err) {
      console.error('🛑 Error detected', err);
      throw err;
    }
  }

  static getColorById(id: number): string {
    const colors = [
      '06B7DB',
      'F5A524',
      'CC3EA4',
      'C20E4D',
      '12A150',
      '6020A0',
      '005BC4',
    ];

    const index = id % colors.length;
    return colors[index];
  }

  static async getMainDataSwipes(): Promise<IMainToolsDataSwipes | null> {
    try {
      const categories = await this.getSwipeCategories();

      let i = 0;
      for (const category of categories) {
        categories[i].items = await this.getSwipes(category.id);
        categories[i].color = this.getColorById(category.id);

        i++;
      }

      return {
        count: categories.length,
        next: null,
        previous: null,
        results: categories,
      };
    } catch (err) {
      console.error('🛑 Error detected', err);
      throw err;
    }
  }
}
